import { render, staticRenderFns } from "./MealsWeekDatepicker.vue?vue&type=template&id=af297b4e"
import script from "./MealsWeekDatepicker.vue?vue&type=script&lang=js"
export * from "./MealsWeekDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports